var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPagePrev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.725 0.700196C6.90833 0.88353 7 1.11686 7 1.4002C7 1.68353 6.90833 1.91686 6.725 2.1002L2.825 6.0002L6.725 9.9002C6.90833 10.0835 7 10.3169 7 10.6002C7 10.8835 6.90833 11.1169 6.725 11.3002C6.54167 11.4835 6.30833 11.5752 6.025 11.5752C5.74167 11.5752 5.50833 11.4835 5.325 11.3002L0.725 6.7002C0.625 6.6002 0.554 6.49186 0.512001 6.3752C0.470667 6.25853 0.45 6.13353 0.45 6.0002C0.45 5.86686 0.470667 5.74186 0.512001 5.6252C0.554 5.50853 0.625 5.4002 0.725 5.3002L5.325 0.700196C5.50833 0.516863 5.74167 0.425195 6.025 0.425195C6.30833 0.425195 6.54167 0.516863 6.725 0.700196Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagePrev);
export default __webpack_public_path__ + "static/media/page_prev.19f91932440048088bcd601de5ae1112.svg";
export { ForwardRef as ReactComponent };